/**
 * Project-Presence — wer ist gerade im aktuellen Projekt online?
 * Daten kommen über die /ws/yjs/project-WS (siehe useProjectLiveUpdates).
 */

import { create } from 'zustand'

export interface PresenceUser {
  id: string
  email: string
  username: string
  firstName?: string | null
  lastName?: string | null
  isGuest?: boolean
}

interface PresenceStore {
  users: PresenceUser[]
  setUsers: (users: PresenceUser[]) => void
}

export const useProjectPresenceStore = create<PresenceStore>((set) => ({
  users: [],
  setUsers: (users) => set({ users }),
}))
